<template>
  <div>
    <fo-header
      selected="/team"
      @selected="(e) => {}">
    </fo-header>
    <teamAll v-show="!$route.params.param"></teamAll>
    <teamDtl v-if="$route.params.param"></teamDtl>
    <fo-footer></fo-footer>
  </div>
</template>

<script>
import teamAll from './Models/teamAll.vue'
import teamDtl from './Models/teamDtl.vue'
export default {
  components: {
    teamAll,
    teamDtl
  },
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Team.vue